import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPeopleEdit: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="people-edit, edit-user, edit-rights, user-rights"><path d="M12 10.25C14.0711 10.25 15.75 8.57107 15.75 6.5C15.75 4.42893 14.0711 2.75 12 2.75C9.92893 2.75 8.25 4.42893 8.25 6.5C8.25 8.57107 9.92893 10.25 12 10.25Z" stroke="currentColor" strokeWidth="1.5"/><path d="M11 20.25H4.5C4.86894 16.3254 7.8098 13.25 12 13.25C13.0928 13.25 14.1006 13.4592 15 13.838" stroke="currentColor" strokeWidth="1.5"/><path d="M13.75 21.25V19.5L19.25 14L21 15.75L15.5 21.25H13.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconPeopleEdit;
